// extracted by mini-css-extract-plugin
export default {"Container":"planning_Container__UMh8h","section-1":"planning_section-1__GWnhu","content":"planning_content__xK5Q+","section-2":"planning_section-2__OdMKd"};